<div class="p-inputgroup">
  <p-dropdown
    [formControl]="carrierId"
    [options]="carriers | async"
    optionValue="id"
    optionLabel="carrierCodeName"
    placeholder="-- Select Carrier --"
    [inputId]="inputId"
    [name]="name"
    [readonly]="readonly"
    [tabindex]="tabindex"
    [filter]="true"
    [editable]="false"
    [resetFilterOnHide]="true"></p-dropdown>
  <button type="button" pButton icon="pi pi-plus" (click)="showAddDialog = true"
    label="Add" [disabled]="carrierId.disabled"></button>
</div>

<app-add-carrier-form
  [(displayDialogFromForm)]="showAddDialog"
  [carriers]="carriers | async"
  (update)="OnCarrierCreated($event)">
</app-add-carrier-form>
